import { gql } from "graphql-request";

const SERVER_GET_PAYROLL_PROCESS_MONTH = gql`
  {
    payrollProcessMonths {
      id
      isOpen
      month
      year
      businessId
      companyId
      __typename
    }
    payrollPeriods {
      id
      name
      type
      isOpen
      displayInPayroll
      isPrincipal
      payrollProcessMonthId
      businessId
      companyId
      updatedAt
      createdAt
      business {
        id
        name
        __typename
      }
      payrollProcessMonth {
        id
        month
        year
        __typename
      }
      __typename
    }
    businesses {
      id
      usePayroll
      businessName
      name
      rut
      address {
        address
        __typename
      }
      __typename
    }
    company {
      id
      name
      __typename
    }
  }
`;

export default SERVER_GET_PAYROLL_PROCESS_MONTH;
